// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-89a2"};